<!--
  dragMenu.vue

  대시보드 드래그 메뉴 플러그인

  NGF 1.2.0 수정 이력

  1) 상태가 변경된 위젯 목록의 드래그 및 더블클릭 이벤트 제거, 글자색 변경 추가
-->

<template>
  <q-scroll-area ref="scroll" class="bs bs-q-scroll-area bs-q-scroll-area-default bs-split-pane-scroll">
    <ul ref="dragMenuList"
        class="dragmenu-depth1"
        v-for="(menu, idx) in menuItems"
        :key="menu.key"
    >
      <!--아이콘처리 클래스 "dragmenu-1dep-01"를 dragmenu-1dep-01 ~ dragmenu-1dep-10까지 스크립트처리 부탁드립니다. -->
      <span :class="`dragmenu-1dep-0${idx + 1}`">{{ $t(`${langFlag}.${menu.title}`) }}</span>
      <li class="dragmenu-item dragTargetEl"
          v-for="child in menu.children"
          :id="child.key || child.target"
          :key="child.key || child.target"
          :size="child.size"
          :context="child.target"
          :license="child.license"
          @dblclick="onDblClick($event, child.target)"
      >
        <div>
          <span>{{ $t(`${langFlag}.${child.target}`) }}</span>
          <!-- 대상 장비 타입 표시 -->
          <template v-for="{label, css, style, value} in displayType(child.deviceSupportType)">
             <span :key="value" :class="['size-xs', css]" :style="`${style}`">{{label}}</span>
          </template>
        </div>
      </li>
    </ul>
  </q-scroll-area>
</template>
<script>
  // Mixin
  import commonValueMixin from '~/mixins/value/commonValueMixin'
  // 플러그인 Import
  import {makeDraggableMenu, setIsDisabledDraggable, destroyDraggable, destroyDroppable} from './dragMenuUI.js'
  // 스토어 헬퍼
  import {createNamespacedHelpers} from 'vuex'
  // 현재 Store에 설정된 언어 얻어오기
  const {mapGetters} = createNamespacedHelpers('common/locale')

  export default {
    name: 'DragMenu',
    components: {},
    directives: {},
    mixins: [commonValueMixin],
    data () {
      return {
        selectedItemId: [],
        beforeSelectedItems: [],
        draggableIds: []
      }
    },
    props: {
      onDrag: {
        type: Function,
        default () {
          return function () {}
        }
      },
      onStart: {
        type: Function,
        default () {
          return function () {}
        }
      },
      onStop: {
        type: Function,
        default () {
          return function () {}
        }
      },
      langFlag: {
        type: String,
        default: '',
        required: true
      },
      menuItems: {
        type: Array,
        default: () => [],
        required: true
      }
    },
    computed: {
      ...mapGetters([
        'getCurrentLocale'
      ])
    },
    beforeCreate () {},
    created () {},
    beforeMount () {},
    mounted () {
      // Mounted 전 Props로 전달되는 경우
      if (this.menuItems.length > 0) {
        for (const parent of this.menuItems) {
          for (const menuItem of parent.children) {
            makeDraggableMenu(`#${menuItem.key}`, this.onDrag, this.onStart, this.onStop)
            this.draggableIds.push(`#${menuItem.key}`)
          }
        }
      }
    },
    beforeUpdate () {},
    updated () {},
    activated () {},
    deactivated () {},
    beforeDestroy () {
      this.draggableIds.forEach(id => {
        destroyDraggable(id)
        destroyDroppable(id)
      })
    },
    destroyed () {},
    errorCaptured () {},
    methods: {
      /*
        이름: onDblClick
        설명: 드래그 메뉴에 더블클릭 이벤트를 발생시킨다.
      */
      onDblClick (event, targetWidget) {
        this.$emit('dblClickWidget', event, targetWidget)
      },
      /**
       * 이름: displayType
       * 설명: 지원 장비 리스트
       */
      displayType (items) {
        return _.filter(this.deviceTypeList, (dt) => _.includes(items, dt.value))
      },
      /**
       * 이름: initStatusOfItems
       * 설명: 메뉴 목록 스타일을 초기화한다.
       */
      initStatusOfItems () {
        for (const category of this.menuItems) {
          if (Array.isArray(category.children)) {
            for (const panel of category.children) {
              const draggableEl = document.getElementById(panel.key)
              const draggableTextEl = draggableEl.getElementsByTagName('span')[0]

              draggableTextEl.style.color = 'black'

              setIsDisabledDraggable(draggableEl, false)
            }
          }
        }
      },
      /*
        이름: changeStatusOfItems
        설명: 선택된 아이템 상태를 변경한다.
      */
      changeStatusOfItems (targetItems, isDisabled = false, allApply = false, dragDisabled = false) {
        // 카테고리 검색
        for (const category of this.menuItems) {
          // 카테고리 하위 항목이 배열이라면 다음 단계 진행
          if (Array.isArray(category.children)) {
            // 카테고리 내에 아이템과 targetItems 비교
            const targetMenuItems = category.children.filter((menu) => allApply ? menu.target : targetItems.includes(menu.target))

            // 검색된 ID가 없으면 다음 카테고리로 이동
            if (targetMenuItems.length === 0) {
              continue
            }

            // 검색된 아이디가 있으면 isDisabled 처리
            for (const targetItem of targetMenuItems) {
              // 상위 li 요소 찾기
              const draggableEl = document.getElementById(targetItem.key)

              // Draggable 요소의 글자 요소 찾기
              const draggableTextEl = draggableEl.getElementsByTagName('span')[0]

              // 색상 변경
              draggableTextEl.style.color = isDisabled ? '#9fbbda' : 'black'

              // disabled - 할지 안할지 모르니까 스타일만 변경
              // dragDisabled true 인 경우에만 Dragable 제한.
              if (dragDisabled) {
                setIsDisabledDraggable(draggableEl, isDisabled)
              }
            }
          }
        }
      }
    },
    watch: {
      /*
        이름: menuItems
        설명: 메뉴 아이템 목록이 변경되면 새롭게 드래그 기능을 설정한다.
      */
      menuItems () {
        this.draggableIds.forEach(id => {
          destroyDraggable(id)
          destroyDroppable(id)
        })
        this.$nextTick(function () {
          this.draggableIds = []
          for (const parent of this.menuItems) {
            for (const menuItem of parent.children) {
              makeDraggableMenu(`#${menuItem.key}`, this.onDrag, this.onStart, this.onStop)
              this.draggableIds.push(`#${menuItem.key}`)
            }
          }
        })
      }
    }
  }
</script>
<style scoped>

</style>
